import { TransportView } from './transport-view.model';
import dayjs from 'dayjs';

export class QuotationView extends TransportView {
  public collapsed?: boolean;

  constructor(data: any = {}) {
    super(data);
    this.collapsed = data.collapsed;
    this.quotationValidityDate = data.quotationValidityDate ? dayjs(data.quotationValidityDate) : dayjs(Date.now());

  }
}
